import axios from 'axios';

const BASE_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:8000'}/api`;

const api = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

// Attach JWT token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('inveira_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Handle 401 globally
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('inveira_token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
